import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";

export const ExtraInfoTable = observer(() => {
  const {
    employeeManagement: { employeeDetail },
  } = useStores();
  return (
    <XTablePagination hidePagination>
      <TableHead>
        <TableRow>
          <TableCell align="center">Ngày tuyển dụng</TableCell>
          <TableCell align="center">Ngày Sinh</TableCell>
          <TableCell align="center">Số Thẻ CC</TableCell>
          <TableCell align="center">Ngày Cấp CC</TableCell>
          <TableCell align="center">Địa Chỉ</TableCell>
          <TableCell align="center">Nguyên Quán</TableCell>
          <TableCell align="center">Nơi Cấp Giấy Khai Sinh</TableCell>
          <TableCell align="center">Số ĐT</TableCell>
          <TableCell align="center">Email</TableCell>
          <TableCell align="center">Số Tài Khoản</TableCell>
          <TableCell align="center">Liên Hệ Khác</TableCell>
          <TableCell align="center">Nguồn Tuyển</TableCell>
          <TableCell align="center">Quan Hệ Nội Bộ</TableCell>
          <TableCell align="center">Trạng Thái</TableCell>
          <TableCell align="center">Ngày Thôi Việc</TableCell>
          <TableCell align="center">Lý Do Thôi Việc</TableCell>
          <TableCell align="center">Ghi Chú</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell align="center">
            {employeeDetail?.information?.employmentStartDate &&
              dateTimeDisplay(employeeDetail?.information?.employmentStartDate)}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.information?.birthDate &&
              dateTimeDisplay(employeeDetail?.information?.birthDate)}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.information?.nationalIDNumber || ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.information?.nationalIDIssueDate &&
              dateTimeDisplay(employeeDetail?.information?.nationalIDIssueDate)}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.information?.nationalIDAddress || ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.information?.registeredHometown || ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.information?.birthCertificatePlace || ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.information?.phoneNumber || ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.information?.email || ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.information?.bankAccountNumber || ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.information?.contact || ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.information?.recruitmentSourceTypeModel?.value ||
              ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.information?.internalRelationship || ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.information?.statusModel?.value || ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.information?.leavingDate &&
              dateTimeDisplay(employeeDetail?.information?.leavingDate)}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.information?.leavingReason || ""}
          </TableCell>
          <TableCell align="center">
            {employeeDetail?.information?.note || ""}
          </TableCell>
        </TableRow>
      </TableBody>
    </XTablePagination>
  );
});
